import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PanelList } from '../../../shared/models/panel-list';
import { SpeedDialMenu } from '../../../shared/models/speed-dial-menu';
import { AssignmentGroupDetails } from '../models/assignment-group-details';
import { FilterMenu } from '../../../shared/models/filter-menu';
import { SortMenu } from '../../../shared/models/sort-menu';
import { AssignmentGroupService } from '../services/assignment-group.service';
import { AssignmentGroupInteractionService } from '../services/assignment-group-interaction.service';
import { CommonService } from '../../../shared/services/common.service';
import { AssignmentGroupSharedDataService } from '../../../shared/services/assignment-group-shared-data.service';
import { AssignmentGroupConstants } from '../assignment-group-constants';

@Component({
  selector: 'app-assignment-group-panel-list',
  templateUrl: './assignment-group-panel-list.component.html',
  styleUrls: ['./assignment-group-panel-list.component.scss']
})
export class AssignmentGroupPanelListComponent implements OnInit,OnDestroy {
  @Output() assignmentGroupToEdit = new EventEmitter<AssignmentGroupDetails>();
  @Input() get scopeId(): any {
    return this._selectedScopeId;
  }
  set scopeId(val: any) {
    if(val){
    this._selectedScopeId = val.data.eQMSScopeId;
    if (val.label.length > 0) this.getAssignmentGroups();
    }
  }
  private _selectedScopeId!:number;
  isAssignmentGroupSliderOpen = false
  isInActiveSelected:boolean = false;
  speedDialOptions!: SpeedDialMenu[];
  isPanelListDataAvailable = false;
  assignmentGroupPanelListInformation: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: true,
    enableSelection: false,
    isCheckBoxContainsDisable: false
  };
  showLoader: boolean = false;
  firstLoad: boolean = true;
  showPanelLoader: boolean = false;
  panelListFetched = false;
  
  constructor(private assignmentGroupService:AssignmentGroupService,
    private assignmentGroupInteractionService :AssignmentGroupInteractionService,
    private commonService: CommonService, 
    private assignmentGroupSharedDataService:AssignmentGroupSharedDataService ) {

  }
  ngOnInit(): void {
    this.assignmentGroupInteractionService.updatePanelList$.subscribe(
      (syncData) => {
        if(syncData) {
        setTimeout(() => {
          this.getAssignmentGroups();
        }, 1000);
      }
      }
    );
  }
  getAssignmentGroups = () => {
    this.firstLoad ? this.showLoader = true : this.showPanelLoader = true;
    this.assignmentGroupService.getAssignmentGroupForScope(this._selectedScopeId,!this.isInActiveSelected)
    .subscribe((assignmentGroups) => {
      this.bindAssignmentGroups(assignmentGroups);
    })
  }
  bindAssignmentGroups = (assignmentGroupDetails: AssignmentGroupDetails[]) => {
    this.assignmentGroupPanelListInformation.lists = this.assignmentGroupSharedDataService.getPanelListDataWithProperty(assignmentGroupDetails, AssignmentGroupConstants.AssignmentGroup_Users);
    this.assignmentGroupPanelListInformation.filters = this.getFiltersForAssignmentGroups();
    this.assignmentGroupPanelListInformation.sort = this.getSortFieldsForAssignmentGroups();
    this.assignmentGroupPanelListInformation.clearSelection = true;
    this.isPanelListDataAvailable = !this.commonService.IsListEmpty(assignmentGroupDetails);
    this.firstLoad ? this.showLoader = false : this.showPanelLoader = false;
    this.panelListFetched = true;
    this.assignmentGroupPanelListInformation = { ...this.assignmentGroupPanelListInformation };
  }
  checkboxSelection(event: Event){
    this.firstLoad = false;
    this.getAssignmentGroups();
  }
  private getFiltersForAssignmentGroups = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Assignment',
        filterFieldName: 'assignmentName',
      },
      {
        filterDisplayName: 'Users',
        filterFieldName: 'usersList',
      }
    );
    return filters;
  };
  private getSortFieldsForAssignmentGroups = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Assignment',
        sortFieldName: 'assignment',
      },
      {
        sortFieldDisplayName: 'Users',
        sortFieldName: 'usersList',
      }
    );
    return sortMenu;
  };
  setActions = (assignmentGroup: AssignmentGroupDetails) => {
    this.speedDialOptions = [];
    this.speedDialOptions.push(
      {
        tooltipOptions: {
          tooltipLabel: "Edit",
          tooltipPosition: "left",
        },
        icon: 'pi pi-pencil',
        command: () => {
          this.editAssignmentGroup(assignmentGroup);
        }
      }
    );
    return this.speedDialOptions;
  }
  calculateIsActiveColor = (isActive: boolean): string => {
    return isActive ? 'is_Active_Yes' : 'is_Active_No';
  }
  editAssignmentGroup = (assignmentGroup:AssignmentGroupDetails) => {
    this.assignmentGroupToEdit.emit(assignmentGroup);
  }
  ngOnDestroy(): void {
    this.assignmentGroupInteractionService.updatePanelList$.unsubscribe();
  }
  getAllUserNames(usersInfo:any):string{
    if(usersInfo)
    {
      return usersInfo.map((user: { assignedUserName: any; })=>user.assignedUserName).join(', ');
    }
    return '';
      }
}
